import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from "@angular/common/http";
import { HttpHelpUtils } from './../../utils/HttpHelpUtils';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class OssFileService {

    client: any;

    constructor(
        private httpHelpUtils: HttpHelpUtils,
        private http: HttpClient
    ) { }

    /**
     * 初始化上传文件参数
     */
    initUploadOptions () {
        return new Promise((resolve, reject) => {
            this.httpHelpUtils.get('psg/common/get-upload-token').then(res => {
                if (res['status'] == 'success') {
                    resolve(res['data']);
                }
            });
        });
    }

    initCclNewUploadOptions (folder?, truckId?, policyType?) {
        return new Promise((resolve, reject) => {
            const params: any = {};
            if (folder) params.folder = folder;
            if (truckId) params.truckId = truckId;
            if (policyType !== undefined && policyType !== null) params.policyType = policyType;
            
            this.httpHelpUtils.get('psg/common/get-ccl-new-upload-token', params).then(res => {
                if (res['status'] == 'success') {
                    resolve(res['data']);
                }
            });
        });
    }

    initCclUploadOptions (dir) {
        return new Promise((resolve, reject) => {
            this.httpHelpUtils.post('ccl/file/getUploadToken',{"dir":dir}).then(res => {
                if (res['code'] == 0) {
                    resolve(res['data']);
                }
            });
        });
    }


    /**
     * @description 闲谈趣社专用
     * @param name  上传文件名称
     * @param fileData  上传文件
     */
    async uploadCClOSSFile(dir, fileData, folder) {
        const that = this;
        let resData = {};
        await this.initCclUploadOptions(dir).then(res => {
            resData = res;
        });
        const suffix = fileData['name'].split('.');
        let uploadName = uuidv4().replaceAll('-', '') + '.' + suffix[1];
        if (fileData['name'].indexOf('.apk')>0) {
            uploadName = uuidv4().replaceAll('-', '') + '.apk';
        }
        const formData = new FormData();
        formData.append("key", resData['dir'] + '/'+ folder +'/' + uploadName);
        formData.append("policy", resData['policy']);
        formData.append("OSSAccessKeyId", resData['accessid']);
        formData.append("success_action_status", "200");
        formData.append("signature", resData['signature']);
        formData.append("file", fileData);
        let result = {};
        return new Promise((resolve, reject) => {
            this.http.post(resData['host'], formData, {
                headers: new HttpHeaders({
                    'upload': 'true',
                })
            }).subscribe(res => {
                if (res['status'] == 200 && res['statusText'] == 'OK') {
                    result['uploadName'] = uploadName;
                    result['status'] = 'success';
                } else {
                    result['status'] = 'error';
                }
                resolve(result);
            });
        });
    }

    /**
     * @description 恒源物流专用
     * @param name  上传文件名称
     * @param fileData  上传文件
     */
    async uploadOSSFile(fileData, folder) {
        const that = this;
        let resData = {};
        await this.initUploadOptions().then(res => {
            resData = res['ossData'];
        });
        const suffix = fileData['name'].split('.');
        let uploadName = uuidv4().replaceAll('-', '') + '.' + suffix[1];
        if (fileData['name'].indexOf('.apk')>0) {
            uploadName = uuidv4().replaceAll('-', '') + '.apk';
        }
        const formData = new FormData();
        formData.append("key", resData['dir'] + '/'+ folder +'/' + uploadName);
        formData.append("policy", resData['policy']);
        formData.append("OSSAccessKeyId", resData['accessid']);
        formData.append("success_action_status", "200");
        formData.append("signature", resData['signature']);
        formData.append("file", fileData);
        let result = {};
        return new Promise((resolve, reject) => {
            this.http.post(resData['host'], formData, {
                headers: new HttpHeaders({
                    'upload': 'true',
                })
            }).subscribe(res => {
                if (res['status'] == 200 && res['statusText'] == 'OK') {
                    result['uploadName'] = uploadName;
                    result['status'] = 'success';
                } else {
                    result['status'] = 'error';
                }
                resolve(result);
            });
        });
    }

    /**
     * @description 苏甲科技新版专用
     * @param fileData 
     * @param folder 
     * @returns 
     */
    async cclnewuploadOSSFile(fileData, folder, truckId?, policyType?,prefix?) {
        
        const that = this;
        let resData = {};
        await this.initCclNewUploadOptions(folder, truckId, policyType).then(res => {
            resData = res['ossData'];
        });
        const suffix = fileData['name'].split('.');
        let uploadName = uuidv4().replaceAll('-', '') + '.' + suffix[1];
        if(prefix){
            uploadName = prefix + uploadName
        }
        if (fileData['name'].indexOf('.apk')>0) {
            uploadName = uuidv4().replaceAll('-', '') + '.apk';
        }
        const formData = new FormData();
        formData.append("key", resData['dir'] + '/'+ folder +'/' + uploadName);
        formData.append("policy", resData['policy']);
        formData.append("OSSAccessKeyId", resData['accessid']);
        formData.append("success_action_status", "200");
        formData.append("signature", resData['signature']);
        formData.append("file", fileData);
        let result = {};
      
        return new Promise((resolve, reject) => {
            this.http.post(resData['host'], formData, {
                headers: new HttpHeaders({
                    'content-type': 'image/jpeg',
                    'upload': 'true',
                })
            }).subscribe(res => {
                if (res['status'] == 200 && res['statusText'] == 'OK') {
                    result['uploadName'] = uploadName;
                    result['status'] = 'success';
                } else {
                    result['status'] = 'error';
                }
                resolve(result);
            });
        });
    }

    /**
     * 预览文件
     * @param foleder 文件夹名称
     * @param imgName 图片名称
     * @param vehicleType 车辆类型或策略类型
     * @returns
     */
    async viewOSSFile (foleder, imgName, vehicleType?) {
        const that = this;
        let result = {};
        const params: any = {
            folder: foleder,
            imgName: imgName
        };
        // 如果传递了 vehicleType 参数，则添加到请求中
        if (vehicleType !== undefined && vehicleType !== null) {
            params.vehicleType = vehicleType;
        }
        console.log('viewOSSFile 调用参数:', params);
        return new Promise((resolve, reject) => {
            that.httpHelpUtils.get('psg/common/view-img', params).then(res => {
                console.log('viewOSSFile 接口返回:', res);
                resolve(res);
            }).catch(err => {
                console.error('viewOSSFile 接口错误:', err);
                reject(err);
            });
        });
    }

    /**
     * 获取下载文件的url
     */
    downOSSFile (filePath, downFileName): string {
        const response = {
            'content-disposition': `attachment; filename=${encodeURIComponent(downFileName)}`
        }
        // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
        return this.client.signatureUrl(filePath, { response });
    }

    ngOnInit(): void {}


}
